import _ from "lodash";
import Grid from "@mui/material/Grid";
import React, { useState, useEffect } from "react";
import { Box } from "@mui/system";
import { Typography } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import { unicodeToString } from "../../../../Js/Common";

const pathToParentMenu = ["root"];

const WwMaxHeight = (props) => {
  const classes = useStyles();
  const [classnames, setClassnames] = useState("");

  useEffect(() => {
    // if (props.data && props.data.class) {
    //   setClassnames(props.data.class);
    // }
  }, [props.data]);

  return (
    <>
      {props.data && props.data.source && (
        <Grid container>
          <Grid item xs={12}>
            <Box
              className={classes.MaxiHeight}
              sx={{
                p: 1,
                pl: 0,
                my: 1,
                mt: 0.5,
                mr: 1,
                border: "1px solid grey",
                borderRadius: 2,
              }}
            >
              <Typography variant="body1" sx={{ color: "primary.main", pl: 1 }}>
                <div
                  className={classnames}
                  id={props.data.myId.self}
                  dangerouslySetInnerHTML={{
                    __html: unicodeToString(props.data.source),
                  }}
                  style={{display: props.initHide && props.initHide.indexOf(props.data.myId.self) > -1 ? 'none' : 'inline-block'}}
                ></div>
              </Typography>
            </Box>
          </Grid>
        </Grid>
      )}
    </>
  );
};
const useStyles = makeStyles({
  MaxiHeight: {
    minHeight: "45px",
    maxHeight: "50vh",
    overflowY: "auto",
  },
});
export default WwMaxHeight;
